import { factory, Factory } from 'almanac-ui/factory'

import { Text as BlazeText, TextProps as BlazeTextProps } from 'blaze-ui/Text/Text'

type TextVariant = 'smallList' | 'largeList' | 'p1' | 'p2' | 'label'

interface TextProps {
  variant: TextVariant
  children: React.ReactNode
  color?: string
}

export type TextFactory = Factory<{
  props: TextProps
  ref: HTMLSpanElement
}>

const variantMap: Record<TextProps['variant'], BlazeTextProps['variant']> = {
  smallList: 'secondary',
  largeList: 'primary',
  p1: 'primary',
  p2: 'secondary',
  label: 'label',
}

export const Text = factory<TextFactory>(({ variant, children, color, ...otherProps }, ref) => {
  return (
    <BlazeText variant={variantMap[variant]} {...otherProps} ref={ref}>
      {children}
    </BlazeText>
  )
})
